export default "__VITE_ASSET__Dd_fI6Ey__"